import { supabase, unwrap } from '@/services/supabase/client'

export interface CatShare {
  token: string
  expires_at: string
}

/**
 * Crea (o reutiliza) el enlace público de un gato tuyo: una foto TUYA, su
 * nombre y tu nombre de pila, durante 30 días. Nada de dónde ni de cuándo.
 * Falla con «no_own_photo» si no tienes ninguna foto tuya de él. (§0084)
 */
export async function createCatShare(catId: string): Promise<CatShare> {
  return unwrap(await supabase.rpc('create_cat_share', { p_cat_id: catId })) as CatShare
}

/** La dirección que se comparte, en el dominio en el que corre la app. */
export function shareUrl(token: string): string {
  return window.location.origin + '/c/' + token
}
